import RoundedCard from "@cle/components/RoundedCard";

const MetricSkeleton = () => (
  <div className="cle-report-detail__reported-metric">
    <span
      className="cle-report-detail__reported-metric-icon placeholder rounded"
      style={{ height: "2.5rem", width: "2.5rem" }}
    />
    <span className="d-flex flex-column gap-2 flex-grow-1 min-w-0">
      <span
        className="placeholder rounded"
        style={{ height: "0.65rem", width: "70%" }}
      />
      <span
        className="placeholder rounded"
        style={{ height: "0.9rem", width: "50%" }}
      />
    </span>
  </div>
);

const TableRowSkeleton = ({ isTotal = false }: { isTotal?: boolean }) => (
  <tr className={isTotal ? "cle-report-detail__overview-total-row" : undefined}>
    <th scope="row">
      <span
        className="placeholder rounded d-block"
        style={{ height: "0.875rem", width: isTotal ? "3rem" : "8rem" }}
      />
    </th>
    <td className="text-end">
      <span
        className="placeholder rounded d-inline-block"
        style={{ height: "0.875rem", width: "2rem" }}
      />
    </td>
    <td className="text-end">
      <span
        className="placeholder rounded d-inline-block"
        style={{ height: "0.875rem", width: "2rem" }}
      />
    </td>
  </tr>
);

const IndberetningDetailSkeleton = () => (
  <div className="cle-report-detail">
    <span className="visually-hidden">Indlæser indberetning</span>
    <section
      className="cle-report-detail__reported-shell placeholder-glow"
      aria-hidden="true"
    >
      <div className="cle-report-detail__reported-hero cle-report-detail__reported-hero-info">
        <div className="cle-report-detail__reported-hero-content d-flex flex-column gap-2">
          <span
            className="placeholder rounded"
            style={{ height: "0.75rem", width: "11rem" }}
          />
          <span
            className="placeholder rounded"
            style={{ height: "2rem", width: "32rem" }}
          />
          <span
            className="placeholder rounded"
            style={{ height: "0.875rem", width: "min(100%, 32rem)" }}
          />
          <span
            className="placeholder rounded"
            style={{ height: "0.875rem", width: "min(100%, 26rem)" }}
          />
        </div>
        <span
          className="placeholder rounded-pill flex-shrink-0"
          style={{ height: "1.75rem", width: "8.5rem" }}
        />
      </div>

      <RoundedCard className="cle-report-detail__reported-summary">
        <div className="cle-report-detail__reported-summary-header mb-3">
          <div className="d-flex flex-column gap-2">
            <span
              className="placeholder rounded"
              style={{ height: "1.25rem", width: "14rem" }}
            />
            <span
              className="placeholder rounded"
              style={{ height: "0.875rem", width: "18rem" }}
            />
          </div>
        </div>
        <div className="cle-report-detail__reported-metrics">
          {Array.from({ length: 4 }).map((_, index) => (
            <MetricSkeleton key={index} />
          ))}
        </div>
      </RoundedCard>

      <RoundedCard bodyClassName="p-0 op">
        <div className="cle-rounded-card__header border-bottom pb-3">
          <div className="cle-rounded-card__header-content d-flex flex-column gap-2">
            <span
              className="placeholder rounded"
              style={{ height: "1.125rem", width: "12rem" }}
            />
            <span
              className="placeholder rounded"
              style={{ height: "0.875rem", width: "min(100%, 28rem)" }}
            />
          </div>
        </div>
        <div className="table-responsive">
          <table className="table align-middle mb-0 cle-report-detail__overview-table">
            <thead>
              <tr>
                <th scope="col">
                  <span
                    className="placeholder rounded d-block"
                    style={{ height: "0.75rem", width: "5rem" }}
                  />
                </th>
                <th scope="col" className="text-end">
                  <span
                    className="placeholder rounded d-inline-block"
                    style={{ height: "0.75rem", width: "5.5rem" }}
                  />
                </th>
                <th scope="col" className="text-end">
                  <span
                    className="placeholder rounded d-inline-block"
                    style={{ height: "0.75rem", width: "9rem" }}
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: 5 }).map((_, index) => (
                <TableRowSkeleton key={index} />
              ))}
              <TableRowSkeleton isTotal />
            </tbody>
          </table>
        </div>
      </RoundedCard>

      <RoundedCard bodyClassName="p-0">
        <div className="cle-rounded-card__header border-bottom pb-3">
          <div className="cle-rounded-card__header-content d-flex flex-column gap-2">
            <span
              className="placeholder rounded"
              style={{ height: "1.125rem", width: "15rem" }}
            />
            <span
              className="placeholder rounded"
              style={{ height: "0.875rem", width: "min(100%, 24rem)" }}
            />
          </div>
        </div>
        <div className="p-3 d-flex flex-column gap-3">
          {Array.from({ length: 3 }).map((_, index) => (
            <div
              key={index}
              className="d-flex align-items-center gap-3 border-bottom pb-3"
            >
              <span
                className="placeholder rounded flex-shrink-0"
                style={{ height: "1.25rem", width: "1.25rem" }}
              />
              <span
                className="placeholder rounded flex-grow-1"
                style={{ height: "0.875rem", maxWidth: "14rem" }}
              />
              <span
                className="placeholder rounded flex-shrink-0"
                style={{ height: "0.875rem", width: "4rem" }}
              />
            </div>
          ))}
        </div>
      </RoundedCard>

      <RoundedCard className="cle-report-detail__reported-timeline">
        <div className="cle-report-detail__reported-timeline-item">
          <span
            className="cle-report-detail__reported-timeline-icon placeholder rounded"
            style={{ height: "2.25rem", width: "2.25rem" }}
          />
          <div className="d-flex flex-column gap-2 flex-grow-1 min-w-0">
            <span
              className="placeholder rounded"
              style={{ height: "1rem", width: "min(100%, 16rem)" }}
            />
            <span
              className="placeholder rounded"
              style={{ height: "0.875rem", width: "min(100%, 28rem)" }}
            />
            <span
              className="placeholder rounded"
              style={{ height: "0.875rem", width: "min(100%, 22rem)" }}
            />
          </div>
        </div>
      </RoundedCard>
    </section>
  </div>
);

export default IndberetningDetailSkeleton;
